import {Directive, OnDestroy, OnInit} from '@angular/core';
import {ISearchableService} from './ISearchableService';
import {SearchService} from './search.service';
import {ASecureForm} from '../../interface/form/ASecureForm';
import {AuthenticationService} from '../../service/authentication.service';
import {SearchFilterBase} from './search-filter-base';
import {EnvironmentService} from '../../service/environment.service';

@Directive()
export abstract class SearchForm extends ASecureForm implements OnInit, OnDestroy
{
    private toggleCount = 0;

    protected constructor(
        protected authenticationService: AuthenticationService,
        protected searchableService: ISearchableService,
        protected searchService: SearchService,
        protected environmentService: EnvironmentService)
    {
        super(authenticationService, environmentService);
    }

    get results()
    {
        return this.searchService.results;
    }

    public isResultListEmpty(): boolean
    {
        return (this.results != null && this.results.content != null && this.results.content.length > 0);
    }

    public abstract create();

    public abstract view(data: any);

    public abstract getDefaultSortField(): string;

    ngOnDestroy(): void
    {
        this.searchService.field = undefined;
        this.searchService.ngOnDestroy();
    }

    ngOnInit(): void
    {
        this.searchService.register(this.searchableService);
        this.toggleCount = 0;
        this.searchService.field = this.getDefaultSortField();
    }

    isDesc(id: string): boolean
    {
        return id == this.searchService.field && this.searchService.direction == 'DESC';
    }

    isAsc(id: string): boolean
    {
        return (!this.isDesc(id)) && id == this.searchService.field;
    }

    toggleDirection(id: string)
    {
        if (++this.toggleCount > 2)
        {
            this.toggleCount = 0;
            this.searchService.field = this.getDefaultSortField();
        }
        this.searchService.direction = this.isAsc(id) ? 'DESC' : 'ASC';
    }

    applySorting(id: string, searchComponent: SearchFilterBase)
    {
        if (id !== null)
        {
            this.searchService.field = id;
            this.toggleDirection(id);
            searchComponent.refresh();
        }
    }
}